export default class CourseModel {
  constructor(courseInfo) {
    this._degreeCourseId = courseInfo.degreeCourseId;
    this._benefitsEligible = courseInfo.benefitsEligible;
    // this._partnerBenefitEligible = courseInfo.partnerBenefitEligible;
    this._name = courseInfo.name;
    this._degreeId = courseInfo.degreeId;
    this._eaCourseURL = courseInfo.eaCourseURL;
    this._courseOfferingId = courseInfo.courseOfferingId;
    this._courseUrl = courseInfo.courseUrl;
    this._LMS = courseInfo.LMS || '';
    this._coursePrefix = courseInfo.coursePrefix || '';
    this._coursePrefixDisplayLabel = courseInfo.coursePrefixDisplayLabel || '';
    this._offerings = courseInfo.offerings || [];
    this._coursePrefixAliases = courseInfo.coursePrefixAliases || '';
    this._courseName = courseInfo.courseName;
    this._courseIsActive = courseInfo.courseIsActive;
    this._courseDescription = courseInfo.courseDescription || '';
    this._courseTooltip = courseInfo.courseTooltip;
    this._recommended = courseInfo.recommended === 'true';
    this._registrationStartDate = courseInfo.registrationStartDate;
    this._registrationEndDate = courseInfo.registrationEndDate;
    this._courseStartDate = this.formatDate(courseInfo.courseStartDate);
    this._courseEndDate = this.formatDate(courseInfo.courseEndDate);
    this._courseFinalisedDate = this.formatDate(courseInfo.courseFinalisedDate);
    this._sortOrder = courseInfo.sortOrder;
    this._isCourseSelected = courseInfo.isCourseSelected;
    this._isSelected = courseInfo.isCourseSelected;
    this._courseType = courseInfo.courseType;
    this._openEdxCourseId = courseInfo.openEdxCourseId;
    this._LMS = courseInfo.LMS;
    this._isPathwayCourse = false;
    this._coursePrerequisiteLabel = courseInfo.coursePrerequisiteLabel;
    this._coursePacing = courseInfo.coursePacing;
    this._courseDesignations = courseInfo.courseDesignations;
    this._courseLength = courseInfo.courseLength;
    this._courseEffortPerHour = courseInfo.courseEffortPerHour;
    this._coursePrerequisite = courseInfo.coursePrerequisite;
    this._isCourseResetAllowed = courseInfo.isCourseResetAllowed;
    this._isCourseResetRequested = courseInfo.isCourseResetRequested;
    this._creditEligible = courseInfo.creditEligible;
    this._termStartDate = this.formatDate(courseInfo.termStartDate);
    this._termEndDate = this.formatDate(courseInfo.termEndDate);

    try {
      this._asuCredits = parseInt(+courseInfo.asuCredits);
    } catch (error) {
      // parse error
    }

    this._term = courseInfo.term;
    this._interestTrack = courseInfo.interestTrack || '';
    this._sessionName = (courseInfo.term || '').toLowerCase() === 'self paced' ? 'Self Paced' : courseInfo.sessionName;

    // enrollmentType can be 'EnrollmentTypeLearnerPay', 'EnrollmentTypePartnerPay', or 'FallbacktoBenefit'
    // FallbacktoBenefit is treated the same as EnrollmentTypeLearnerPay (shows in learner section with fee)
    this._enrollmentType = courseInfo.enrollmentType || 'FallbacktoBenefit';
  }

  get courseOfferingId() {
    return this._courseOfferingId;
  }

  formatDate(str) {
    if (!str || str.indexOf('/') >= 0) return str;

    return [str.split('-')[1], str.split('-')[2], str.split('-')[0]].join('/');
  }
}
